import { Box, Card, CardContent, Typography } from "@mui/material";
import CountUp from "react-countup";

const AnalyticsCard = ({
  title,
  count,
  icon: IconComponent,
  color,
  children,
  sx = {},
}) => (
  <Card
    sx={{
      borderRadius: 3,
      mb: 1,
      boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
      cursor: "pointer",
      transition: "0.3s",
      minHeight: 100,
      "&:hover": {
        transform: "translateY(-4px)",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
      },
      position: "relative",
      overflow: "hidden",
      background: "#fff",
      borderRight: `3px solid ${color}`,
      ...sx,
    }}
  >
    <Box
      component="svg"
      viewBox="0 0 400 400"
      sx={{
        position: "absolute",
        top: -100,
        right: -100,
        width: 230,
        height: 230,
        pointerEvents: "none",
      }}
    >
      <circle cx="200" cy="200" r="200" fill={color} opacity={0.03} />
    </Box>

    <CardContent sx={{ position: "relative", zIndex: 1 }}>
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: 500, color: "text.secondary" }}
      >
        {title.toUpperCase()}
      </Typography>

      {count != null && (
        <Typography variant="h2" sx={{ fontWeight: 200, color, mt: 1 }}>
          {typeof count === "number" ? (
            <CountUp end={count} duration={1.5} separator="," />
          ) : (
            count
          )}
        </Typography>
      )}

      {children && <Box sx={{ mt: 1 }}>{children}</Box>}

      {IconComponent && (
        <Box
          sx={{
            position: "absolute",
            top: 10,
            right: 16,
            fontSize: 25,
            color,
            opacity: 0.5,
          }}
        >
          <IconComponent fontSize="inherit" />
        </Box>
      )}
    </CardContent>
  </Card>
);

export default AnalyticsCard;

export const TrendItem = ({ label, value, icon: Icon, color }) => (
  <Box
    sx={{ display: "flex", justifyContent: "space-between", mb: -1, gap: 6 }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Icon sx={{ fontSize: 18, color }} />
      <Typography variant="caption" sx={{ color: "text.secondary" }}>
        {label}
      </Typography>
    </Box>
    <Typography variant="subtitle2" sx={{ fontWeight: 600, color }}>
      {value}
    </Typography>
  </Box>
);

export const SectionHeader = ({ title }) => (
  <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
    <Box
      sx={{
        width: 5,
        height: 25,
        background: "linear-gradient(180deg, #e9630e, #e2e456)",
        borderRadius: 2,
        mr: 2,
      }}
    />
    <Typography
      variant="h5"
      sx={{
        fontWeight: 500,
        color: "#111111c2",
        textTransform: "uppercase",
        letterSpacing: 0.5,
      }}
    >
      {title}
    </Typography>
  </Box>
);
